import money from '@paybygroup/baelish';
export * from '@paybygroup/baelish';
export default money;



// WEBPACK FOOTER //
// ./src/lib/money.js